import React, { useEffect, useState, useRef } from 'react';
import './BotTrainingPage.css';
import LinksComponent from './LinksComponent';
import FilesComponent from './FilesComponent';
import CustomLayout from '../../layouts/Customlayout';
import axios from 'axios';
import config from '../../config';
import closeIcon from '../../assets/botTrainingIcons/closeIcon.svg';
import ShopifyLinks from './ShopifyComponent';
import ZidComponent from './ZidComponent';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BotTraining = () => {
  const { t } = useTranslation();
  const teamChatTranslations = t('botTrainingPage');
  console.log(teamChatTranslations)

  const [activeTab, setActiveTab] = useState('links');
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [testingMsgList, setTestingMsgList] = useState([{ message: t('botTrainingPage.initialBotMessage'), from_bot: true }]);
  const [testingMessage, setTestingMessage] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') || 'web-chat';
  const testingMsgListRef = useRef(null);

  const handleMouseMove = (e) => {
    setPosition({ x: e.clientX + 10, y: e.clientY + 10 });
  };

  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen);
    setTestingMsgList([{ message: t('botTrainingPage.initialBotMessage'), from_bot: true }]);
  };

  useEffect(() => {
    if (testingMsgListRef.current) {
      testingMsgListRef.current.scrollTop = testingMsgListRef.current.scrollHeight;
    }
  }, [testingMsgList?.length]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSendTestingMsg();
  };

  const handleSendTestingMsg = () => {
    if (testingMessage.length > 0) {
      setTestingMsgList((prevList) => [...prevList, { message: testingMessage, from_bot: false }]);
      setTestingMessage('');
      setTestingMsgList((prevList) => [...prevList, { message: t('botTrainingPage.loadingMessage'), from_bot: true }]);

      let formData = new FormData();
      formData.append('question', testingMessage);
      formData.append('testing_type', activeTab);

      const headers = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${localStorage.getItem('token')}`,
          Accept: 'application/json'
        }
      };

      axios
        .post(`${config.apiUrl}bot-test-website/`, formData, headers)
        .then((res) => {
          setTestingMsgList((prevList) => {
            const updatedList = prevList.slice(0, prevList.length - 1);
            return [...updatedList, { message: res.data.data, from_bot: true }];
          });
          setTestingMessage('');
        })
        .catch((error) => {
          console.error('Error sending message:', error);
        });
    }
  };

  const UserInfo = JSON.parse(localStorage.getItem('UserObject'));
  const shopifyZid = UserInfo?.mode;

  const tabOptions = [
    { id: 'links', label: t('botTrainingPage.linksTab'), icon: 'https://cdn-icons-png.flaticon.com/512/3037/3037366.png' },
    { id: 'files', label: t('botTrainingPage.filesTab'), icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5afpx3wsQgzXLHss8vgGV55nP5_B6fdhK6w&s' },
    ...(shopifyZid === 'shopify'
      ? [
          {
            id: 'products',
            label: t('botTrainingPage.shopifyTab'),
            icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjVS_XEsmNvLJnLEg3F_SkIwuL3rAEi--_r-bY28x1Wgmz5pKqOf5qQawM0S4W9yA3tIw&usqp=CAU'
          }
        ]
      : shopifyZid === 'zid'
      ? [
          {
            id: 'products_zid',
            label: t('botTrainingPage.zidTab'),
            icon: 'https://wasmenia.com/_next/image?url=https%3A%2F%2Fstrapi.wasmenia.com%2Fuploads%2Fzid_9f78064663.svg&w=828&q=75'
          }
        ]
      : [])
  ];

  return (
    <CustomLayout>
      <div className="container">
        <div className="header">
          <div className="header-title relative">
            <span>{t('botTrainingPage.title')}</span>
            <span
              className="header-info ml-2 cursor-help inline-flex items-center justify-center"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              onMouseMove={handleMouseMove}
            >
              ⓘ
              {showTooltip && (
                <div className="fixed z-50 w-64" style={{ left: `${position.x}px`, top: `${position.y}px` }}>
                  <div className="bg-white rounded-lg shadow-lg border border-gray-200">
                    <div className="p-3">
                      <h4 className="text-sm font-semibold text-gray-800 mb-2">
                        {t('botTrainingPage.tooltipTitle')}
                      </h4>
                      <p className="text-xs text-gray-600 leading-relaxed">
                        {t('botTrainingPage.tooltipDescription')}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </span>
          </div>
          <button className="test-bot-button" onClick={togglePanel}>
            {t('botTrainingPage.testButton')}
          </button>
        </div>

        <div className="flex flex-wrap gap-4 mt-6 mb-6">
          {tabOptions.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 rounded-full text-sm font-semibold flex items-center gap-2 shadow-md transition \
                ${activeTab === tab.id ? 'bg-[#7F28F8] text-white' : 'bg-gray-100 text-gray-700 hover:bg-[#EAE6FD] hover:text-[#7F28F8]'}`}
            >
              <img src={tab.icon} alt={`${tab.label} icon`} style={{ width: 20, height: 20 }} />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        {activeTab === 'links' && <LinksComponent />}
        {activeTab === 'files' && <FilesComponent />}
        {activeTab === 'products' && <ShopifyLinks />}
        {activeTab === 'products_zid' && <ZidComponent />}

        <div className={`testbot-panel ${isPanelOpen ? 'testbot-panel--open' : 'testbot-panel--closed'}`}>
          <div className="testbot-panel-header">
            <div className="testbot-panel-content">
              <h2 className="testbot-panel-title">{t('botTrainingPage.botPreviewTitle')}</h2>
              <button onClick={togglePanel} className="testbot-panel-close-button">
                <img src={closeIcon} alt="closeIcon" />
              </button>
            </div>
          </div>

          <div className="fixed-container" style={{ margin: '40px' }}>
            <div className="chat-box" style={{ border: `1px solid #7F28F8` }}>
              <div className="header_chat" style={{ background: '#7F28F8' }}>
                <div>
                  <img
                    src={
                      'https://www.shutterstock.com/image-vector/chat-bot-logo-design-concept-600nw-1938811039.jpg'
                    }
                    alt="Logo"
                  />
                </div>
              </div>
              <div className="messages-container" ref={testingMsgListRef}>
                {testingMsgList.map((msg, index) => (
                  <div
                    key={index}
                    className={`message ${msg.from_bot ? 'business-message' : 'user-message'}`}
                    style={{ background: msg.from_bot ? '#eee' : '#7F28F8' }}
                  >
                    <p style={{ color: msg.from_bot ? '#000' : '#fff' }}>{msg.message}</p>
                  </div>
                ))}
              </div>
              <div className="input-container">
                <input
                  type="text"
                  placeholder={t('botTrainingPage.inputPlaceholder')}
                  style={{ border: `1px solid #7F28F8` }}
                  value={testingMessage}
                  onChange={(e) => setTestingMessage(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <button type="button" onClick={handleSendTestingMsg}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M19.5656 12.5913C19.4092 12.9268 19.1426 13.1929 18.8233 13.3529L6.75036 19.4461C5.89387 19.8649 4.86032 19.5233 4.42563 18.6844C4.2343 18.2793 4.19549 17.822 4.32795 17.3955L5.64831 13.0972C5.7692 12.7037 6.13274 12.435 6.54448 12.435H11.1654C11.505 12.4337 11.7828 12.1592 11.7905 11.8101C11.7884 11.4663 11.514 11.1885 11.1654 11.1851H6.54788C6.13452 11.1851 5.76995 10.9144 5.65042 10.5187L4.34749 6.20514C4.07489 5.3055 4.58948 4.34594 5.50008 4.07643C5.92157 3.94393 6.37753 3.98415 6.76989 4.19362L18.8233 10.2868C19.6653 10.7168 20.0041 11.7517 19.5656 12.5913Z"
                      fill="#7F28F8"
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="flex items-center justify-center">
                <a href="https://jaweb.me/" target="_blank" rel="noopener noreferrer">
                  <span className="text-gray-500">{t('botTrainingPage.poweredBy')}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CustomLayout>
  );
};

export default BotTraining;
